import type { SearchResultJobV5 } from '@seek/chalice-types';
import { Stack } from 'braid-design-system';
import type { ReactNode } from 'react';

import SearchResultList from '../SearchResultList/SearchResultList';
import { UpToDateLastPage } from '../UpToDateLastPage/UpToDateLastPage';

export interface ListViewProps {
  resultSummary: ReactNode;
  hideResults: boolean;
  jobs: SearchResultJobV5[];
  isCompanySearch: boolean;
  setCurrentJob: (job: SearchResultJobV5) => void;
  selectedJobId?: string;
  currentPageNumber: number;
  totalPages: number;
  isNewToYou: boolean;
  showSummary?: boolean;
}

export default ({
  resultSummary,
  hideResults,
  jobs,
  isCompanySearch,
  setCurrentJob,
  selectedJobId,
  currentPageNumber,
  totalPages,
  isNewToYou,
  showSummary = true,
}: ListViewProps) => (
  <>
    {showSummary ? resultSummary : null}
    {hideResults ? null : (
      <Stack space="medium">
        {jobs.length > 0 && (
          <SearchResultList
            jobs={jobs}
            isCompanySearch={isCompanySearch}
            setCurrentJob={setCurrentJob}
            selectedJobId={selectedJobId}
            currentPageNumber={currentPageNumber}
            isNewToYou={isNewToYou}
          />
        )}
        {currentPageNumber === totalPages && isNewToYou && <UpToDateLastPage />}
      </Stack>
    )}
  </>
);
